<template>
<v-card flat :disabled="load">
    <v-card-title>Estatisticas de laudos liberados</v-card-title>
    <v-card-text>
        <v-chip-group v-model="selection" active-class="primary accent-4 white--text" column>
            <v-chip>Total</v-chip>
            <v-chip>Percentual
                <strong class="ml-2">
                    %
                </strong>
            </v-chip>
            <!-- <v-chip>Luados manuais</v-chip> -->
        </v-chip-group>
          <div class="text-center">
            <v-chip-group v-model="selectAno" active-class="primary accent-4 white--text" column>
            <v-chip>{{date.getFullYear()}}</v-chip>
            <v-chip>{{date.getFullYear() - 1}}</v-chip>
            <!-- <v-chip>Luados manuais</v-chip> -->
        </v-chip-group>
        </div>
    </v-card-text>

    <div id="chart">
        <apexchart v-if="series[0].data.length > 0" type="line" height="350" @dataPointMouseEnter="dataPointSelectionHandler" :options="chartOptions" :series="series"></apexchart>
    </div>
</v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import service from './../services/userservice'
import { EventBus } from './../main'

export default {
  name: 'estatisticasAno',
  components: {
    apexchart: VueApexCharts
  },
  mounted () {
    this.carregarEstatisticas()
    EventBus.$on('load', this.loadStop)
    this.selectAno = 0
    this.selection = 0
  },
  data () {
    return {
      load: false,
      selection: '',
      selecionado: '',
      selectAno: '',
      anoSelecionado: '',
      liberacoes: '',
      date: new Date(),
      mLiberacao: '',
      series: [{
        name: '',
        data: []
      },
      {
        name: '',
        data: []
      }
      ],
      chartOptions: {

        chart: {
          id: 'myChart',
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },

        dataLabels: {
          enabled: false,
          formatter: function (val) {
            return val + '%'
          }
        },
        stroke: {
          width: [0, 7, 5],
          curve: 'straight',
          dashArray: [0, 0, 0]
        },
        // title: {
        //   text: 'Page Statistics',
        //   align: 'left'
        // },

        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return val + ' - ' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + ''
          }
        },
        markers: {
          size: 5,
          hover: {
            sizeOffset: 5
          }
        },
        xaxis: {
          categories: []
        },
        tooltip: {
          y: [{
            title: {
              formatter: function (val) {
                return val + ' (OS)'
              }
            }
          },
          {
            title: {
              formatter: function (val) {
                return val + ' (OS)'
              }
            }
          },
          {
            title: {
              formatter: function (val) {
                return val + ' %'
              }
            }
          }
          ]
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3'], // takes an array which will be repeated on columns
            opacity: 0.1
          }
        }
      }
    }
  },
  methods: {
    loadStop (i) {
      this.load = i
    },
    dataPointSelectionHandler (e, chartContext, config) {
      console.log(this.series[config.seriesIndex].data)
    },
    async carregarEstatisticas () {
      let date = new Date()
      this.load = true
      EventBus.$emit('loadStop', 1)
      let ano = date.getFullYear()
      service.listarestatisticasAnoMes([ano - 1, ano], date.getDate()).then(r => {
        if (r.status === 200) {
          console.log(r.data.liberacoes)
          this.liberacoes = r.data.liberacoes
          for (let i = 0; i < this.liberacoes.length; i++) {
            const ano = this.liberacoes[i]
            for (let j = 0; j < ano.liberacaoAnual.length; j++) {
              if (i === 0) {
                const mes = ano.liberacaoAnual[j]
                // this.series[i + 1].name = ano.ano
                // this.series[i + 1].type = 'column'
                // this.series[i + 1].data.push(mes.TotalLaudosLiberados)
                this.chartOptions.xaxis.categories.push(mes.Mes)
              } else {
                const mes = ano.liberacaoAnual[j]
                this.series[i - 1].name = 'Manual'
                this.series[i - 1].type = 'column'
                this.series[i - 1].data.push(mes.QtdLaudosManuais)

                this.series[i].name = 'Automático'
                this.series[i].type = 'column'
                this.series[i].data.push(mes.QtdLaudosAutomaticos)
                // this.series[i - 1].data.push(mes.QtdLaudosAutomaticos)
              }
            }
          }
          if (this.series[0].data) {
            for (let i = 0; i < 12; i++) {
              const e = this.series[0].data[i]
              if (e == null) {
                this.series[0].data.push(null)
              }
            }
          }
          console.log(this.series[0].data)
        }
      }).finally(() => {
        this.load = false
        EventBus.$emit('loadStop', -1)
      })
    },
    formatDigit (value) {
      const val = Number(value.toString().replace(',', '.'))
      if (!val) return '0'
      const valueString = val.toFixed().replace('.', '.')
      return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    mudarTipoDeEstatisticas () {
      // console.log(val)
      switch (this.selecionado) {
        case 1:
          for (let i = 0; i < this.liberacoes.length; i++) {
            const ano = this.liberacoes[i]
            for (let j = 0; j < ano.liberacaoAnual.length; j++) {
              if (i === 0) {
                if (this.anoSelecionado === 1) {
                  const mes = ano.liberacaoAnual[j]
                  let paux = ((mes.QtdLaudosAutomaticos / mes.TotalLaudosLiberados) * 100)
                  let porcentagem = this.formatDigit(paux - 100) * -1
                  this.series[i + 1].data.splice(j, 1, porcentagem)
                  paux = ((mes.QtdLaudosManuais / mes.TotalLaudosLiberados) * 100)
                  porcentagem = this.formatDigit(paux - 100) * -1
                  this.series[i].data.splice(j, 1, porcentagem)
                }
              } else {
                const mes = ano.liberacaoAnual[j]
                let paux = ((mes.QtdLaudosAutomaticos / mes.TotalLaudosLiberados) * 100)
                let porcentagem = this.formatDigit(paux - 100) * -1
                this.series[i - 1].data.splice(j, 1, porcentagem)
                paux = ((mes.QtdLaudosManuais / mes.TotalLaudosLiberados) * 100)
                porcentagem = this.formatDigit(paux - 100) * -1
                this.series[i].data.splice(j, 1, porcentagem)
              }
            }
          }
          /* for (let i = 0; i < this.liberacoes.length; i++) {
                      const ano = this.liberacoes[i]
                      for (let j = 0; j < ano.liberacaoAnual.length; j++) {
                        if (i === 0) {
                          const mes = ano.liberacaoAnual[j]
                          let paux = ((mes.QtdLaudosAutomaticos / mes.TotalLaudosLiberados) * 100)
                          let porcentagem = this.formatDigit(paux - 100)
                          this.series[i + 1].data.splice(j, 1, porcentagem)
                        } else {
                          const mes = ano.liberacaoAnual[j]
                          let paux = ((mes.QtdLaudosAutomaticos / mes.TotalLaudosLiberados) * 100)
                          let porcentagem = this.formatDigit(paux - 100)
                          this.series[i - 1].data.splice(j, 1, porcentagem)
                        }
                      }
                    } */
          break
          /* case 2:
                      for (let i = 0; i < this.liberacoes.length; i++) {
                        const ano = this.liberacoes[i]
                        for (let j = 0; j < ano.liberacaoAnual.length; j++) {
                          if (i === 0) {
                            const mes = ano.liberacaoAnual[j]
                            this.series[i + 1].data.splice(j, 1, mes.QtdLaudosManuais)
                          } else {
                            const mes = ano.liberacaoAnual[j]
                            this.series[i - 1].data.splice(j, 1, mes.QtdLaudosManuais)
                          }
                        }
                      }
                      break */
        default:
          for (let i = 0; i < this.liberacoes.length; i++) {
            const ano = this.liberacoes[i]
            for (let j = 0; j < ano.liberacaoAnual.length; j++) {
              if (i === 0) {
                // const mes = ano.liberacaoAnual[j]
                // this.series[i + 1].data.splice(j, 1, mes.TotalLaudosLiberados)
              } else {
                const mes = ano.liberacaoAnual[j]
                // let paux = ((mes.QtdLaudosAutomaticos / mes.TotalLaudosLiberados) * 100)
                // let porcentagem = this.formatDigit(paux - 100) * -1
                this.series[i - 1].data.splice(j, 1, mes.QtdLaudosManuais)
                // paux = ((mes.QtdLaudosManuais / mes.TotalLaudosLiberados) * 100)
                // porcentagem = this.formatDigit(paux - 100) * -1
                this.series[i].data.splice(j, 1, mes.QtdLaudosAutomaticos)
                // const mes = ano.liberacaoAnual[j]
                // this.series[i - 1].data.splice(j, 1, mes.TotalLaudosLiberados)
              }
            }
          }
          break
      }
      // eslint-disable-next-line no-undef
      ApexCharts.exec('myChart', 'updateSeries', this.series)
    }
  },
  watch: {
    selection: function (val) {
      this.selecionado = val
      this.mudarTipoDeEstatisticas()
      this.fullName = val + ' ' + this.lastName
    },
    selectAno: function (val) {
      this.anoSelecionado = this.date.getFullYear() - val
      this.mudarTipoDeEstatisticas()
      console.log(this.anoSelecionado)
    }
  }
}
</script>
